import React from 'react';
import {Pie} from "@ant-design/plots";
import {Spin, Button, Tooltip, Card} from "antd";
import {FileExcelFilled} from "@ant-design/icons";
import * as XLSX from 'xlsx';

const CruiseStatus = ({data, user, loading}) => {

    const handleDownload = () => {
        const title = 'Seyir_Durumu_Raporu';
        const workbook = XLSX.utils.book_new();

        const header = [
            ['Rapor Tipi:', 'Seyir Durumu'],
            ['Rapor Oluşturma Tarihi:', new Date().toLocaleString()],
            ['Raporu Oluşturan:', user?.name || 'Bilinmiyor'],
            [],
        ];

        const summaryHeader = [['Seyir Durumu', 'Araç Sayısı']];
        const summaryBody = data.map(item => [item.type, item.value]);

        const detailsHeader = [['Durum', 'Plaka', 'Kapı Numarası']];
        const detailsBody = data.flatMap(item =>
            item.vehicles.map(vehicle => [
                item.type,
                vehicle.plateNumber,
                vehicle.operationNumber,
            ])
        );

        const worksheetData = [
            ...header,
            ...summaryHeader,
            ...summaryBody,
            [],
            ...detailsHeader,
            ...detailsBody,
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const maxWidths = worksheetData[0].map((_, colIndex) =>
            Math.max(...worksheetData.map(row => (row[colIndex]?.toString().length || 0)))
        );
        worksheet['!cols'] = maxWidths.map(width => ({width}));

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Seyir Durumu Raporu');
        XLSX.writeFile(workbook, `${title}.xlsx`);
    };

    const config = {
        appendPadding: 10,
        data: data,
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        animation: false,
        label: {
            type: 'inner',
            offset: '-30%',
            content: ({percent}) => `${(percent * 100).toFixed(0)}%`,
            style: {fontSize: 14, textAlign: 'center'},
        },
        interactions: [{type: 'element-active'}],
    };

    return (
        <Card
            type="inner"
            size="small"
            title="Seyir Durumu"
            extra={
                <Tooltip title="Rapor olarak indir">
                    <Button
                        type="text"
                        icon={<FileExcelFilled/>}
                        onClick={handleDownload}
                    />
                </Tooltip>
            }
        >
            <div style={{position: 'relative', height: 355}}>
                {loading ? (
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)'
                    }}>
                        <Spin/>
                    </div>
                ) : (
                    <Pie {...config} style={{height: 355}}/>
                )}
            </div>
        </Card>
    );
};

export default CruiseStatus;
